import React, { useState } from "react";
import { Web3Context } from "./Web3Context"; // Jangan lupa adjust path sesuai lokasi file Web3Context.js

const Web3Provider = ({ children }) => {
  const [address, setAddress] = useState(null);
  const [addressGlobal, setAddressGlobal] = useState(null);
  const [chainId, setChainId] = useState(null);
  const [blockSafuBalanceGlobal, setBlockSafuBalanceGlobal] = useState("0");

  return (
    <Web3Context.Provider
      value={{
        address,
        setAddress,
        addressGlobal,
        setAddressGlobal,
        chainId,
        setChainId,
        blockSafuBalanceGlobal,
        setBlockSafuBalanceGlobal,
      }}
    >
      {children}
    </Web3Context.Provider>
  );
};

export default Web3Provider;
